import { useEffect, useRef, useState } from "react";
import { Alert, Button, Spinner, Table } from "../../../Components/ui";
import { notificationCenterService, type NotificationEventParticipant } from "../../../api/services/notification-center.service";
import { ListPagination } from "./NotificationListControls";

export default function NotificationEventParticipants({ eventName, refreshKey = 0 }: { eventName: string; refreshKey?: number }) {
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [retry, setRetry] = useState(0);
  const [result, setResult] = useState<{ count: number; results: NotificationEventParticipant[] } | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const generation = useRef(0);
  useEffect(() => {
    if (!open || !eventName) return;
    const version = ++generation.current;
    setLoading(true); setResult(null); setError("");
    const timer = window.setTimeout(() => {
      notificationCenterService.getEventParticipants({ event_name: eventName, page, page_size: 20 }).then(({ data }) => {
        if (generation.current === version) setResult(data);
      }).catch(() => {
        if (generation.current === version) setError("참여 명부를 불러오지 못했습니다.");
      }).finally(() => { if (generation.current === version) setLoading(false); });
    }, 250);
    return () => { generation.current += 1; window.clearTimeout(timer); };
  }, [eventName, open, page, retry, refreshKey]);

  return <section className="my-3" aria-label="이벤트 참여 명부">
    <Button color="soft-primary" size="sm" onClick={() => { generation.current += 1; setResult(null); setOpen(!open); setPage(1); }} aria-expanded={open}>
      {open ? "참여 명부 닫기" : "참여 명부 보기"}
    </Button>
    {open ? <div className="border rounded p-3 mt-2">
      <h6 className="break-words">{eventName}</h6>
      {loading ? <p role="status"><Spinner size="sm" /> 참여 명부 확인 중</p> : null}
      {error ? <Alert color="warning">{error} <Button size="sm" onClick={() => setRetry((current) => current + 1)}>다시 불러오기</Button></Alert> : null}
      {result ? <>
        <p>참여 완료 등록 {result.count.toLocaleString()}명</p>
        {result.results.length ? <div className="overflow-x-auto"><Table className="align-middle mb-0"><thead><tr><th>고객</th><th>등록 확인</th></tr></thead><tbody>
          {result.results.map((row) => <tr key={row.id}>
            <td>{row.name}<br /><small>{row.phone_num || "-"}</small></td>
            <td><small>{row.confirmed_by_name || "관리자"}<br />{new Date(row.confirmed_at).toLocaleString("ko-KR")}</small></td>
          </tr>)}
        </tbody></Table></div> : <p className="text-muted">등록된 참여 고객이 없습니다.</p>}
        <ListPagination label="참여 고객" page={page} count={result.count} loading={loading} onChange={(next) => { generation.current += 1; setResult(null); setPage(next); }} />
      </> : null}
    </div> : null}
  </section>;
}
